/* This example requires Tailwind CSS v2.0+ */
import { InformationCircleIcon } from "@heroicons/react/solid";

export default function InfoMsgAction(props) {
  return (
    <div className="rounded-md bg-support-yellow-50 p-4 shadow-sm">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-6 w-6 text-support-yellow-500"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-base text-support-yellow-700">{props.msg}</p>
          <p className="mt-3 text-sm md:mt-0 md:ml-6">
            <button
              onClick={props.onClick}
              className="whitespace-nowrap font-semibold text-support-yellow-700 hover:text-support-yellow-600"
            >
              {props.action} <span aria-hidden="true">&rarr;</span>
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
